import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor(private httpService: HttpClient,
    private router: Router) { }

  ngOnInit(): void {
    // Getting name from impersonate page
    localStorage.removeItem('name');
  }
  redirect(url:string){
    this.router.navigate(['/'+url]);
  }
}
